<template>
    <div style="width:200px;height:200px;" >

        <!-- <v-carousel :show-arrows="false" height="350">
            <v-carousel-item v-for="(item, i) in items" :key="i" :src="getImage('/' + item.cover_url)"></v-carousel-item>
        </v-carousel> -->

        <v-card v-if="product.slug" style="display:block;">

            <v-img :src="getImage('/' + product.cover)" class="red--text">
            </v-img>
            <v-card-text class="fill-height align-end" v-text="product.title">
            </v-card-text>
            Categories:
            <v-chip v-for="category in product.categories" :key="category.id" :to="'/category/' + category.slug" small>
                {{ category.name }}
            </v-chip>
            <v-card-actions>
                <v-btn block color="success" @click="buy" :disabled="product.stock == 0">
                    <v-icon>mdi-cart-plus</v-icon> &nbsp;
                    BUY
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card-text style="display:none;">
            <v-simple-table dense>
                <tbody>
                    <tr>
                        <td>
                            <v-icon>mdi-account-tie</v-icon> Author
                        </td>
                        <td>{{ product.author }}</td>
                    </tr>
                    <tr>
                        <td>
                            <v-icon>mdi-bullhorn</v-icon> Publisher
                        </td>
                        <td>{{ product.publisher }}</td>
                    </tr>
                    <tr>
                        <td>
                            <v-icon>mdi-weight</v-icon> Weight
                        </td>
                        <td>{{ product.weight }} gr</td>
                    </tr>
                    <tr>
                        <td>
                            <v-icon>mdi-format-list-bulleted</v-icon> Stock
                        </td>
                        <td>{{ product.stock }} item</td>
                    </tr>
                    <tr>
                        <td>
                            <v-icon>mdi-eye</v-icon> Views
                        </td>
                        <td>{{ product.views }}</td>
                    </tr>
                    <tr>
                        <td>
                            <v-icon>mdi-cash</v-icon> Price
                        </td>
                        <td class="orange--text">Rp {{ product.price.toLocaleString('id-ID') }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
            Description: <br>
            {{ product.description }}
            <br>
            Categories:
            <v-chip v-for="category in product.categories" :key="category.id" :to="'/category/' + category.slug" small>
                {{ category.name }}
            </v-chip>
        </v-card-text>


    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    data: () => ({
        product: {}, // objek product
        items: [],
    }),
    created() {
        this.go(),
            this.product_slider()

    },
    computed: {
        ...mapGetters({
            carts: 'cart/carts',
        })
    },
    methods: {
        ...mapActions({
            addCart: 'cart/add',
            setAlert: 'alert/set',
        }),
        buy() {
            this.addCart(this.product)
            //this.$store.dispatch('cart/add', this.product)
            this.setAlert({
                status: true,
                color: 'success',
                text: 'Added to cart',
            })
            this.$router.push('/')
        },
        go() {
            let { slug } = this.$route.params
            let url = '/products/slug/' + slug
            url = url + '?page=' + this.page
            url = encodeURI(url)
            this.axios.get(url)
                .then((response) => {
                    let { data } = response.data
                    this.product = data

                })

                .catch((error) => {
                    let { responses } = error
                    console.log(responses)
                })
        },
        product_slider() {
            let { slug } = this.$route.params
            let url = '/product/slider/' + slug
            url = url + '?page=' + this.page
            url = encodeURI(url)
            this.axios.get(url)
                .then((response) => {
                    let { data } = response.data
                    this.items = data

                })
                .catch((error) => {
                    let { responses } = error
                    console.log(responses)
                })
        },

    }
};
</script>
